import type { Theme } from '@mui/material';

export const styles = {
  header: (theme: Theme) => ({
    textAlign: 'center',
    fontWeight: 'bold',
    py: 2,
    backgroundColor: theme.colors.neutral[300],
  }),

  content: (theme: Theme) => ({
    py: 5,
    justifyContent: 'center',
    backgroundColor: theme.colors.neutral[200],
  }),
};
